module.exports = __webpack_public_path__ + "components/country-flag/static/cr-67dc4cafc72cd9ea5b0e37cc2a814cba.svg";